import React from "react";

export const Manifesto = () => {
  return (
    <section className="px-5 md:px-10 py-14" data-testid="manifesto-section">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div className="-rotate-1">
          <h2 className="font-display text-5xl md:text-7xl text-[#1A1A1A]">
            <span className="scribble-underline">the manifesto</span>
          </h2>
          <p className="font-display text-3xl md:text-4xl text-[#E8742C] mt-2">
            (we wrote it in crayon)
          </p>
        </div>
        <div className="crayon-card relative px-6 md:px-10 py-8 rotate-1">
          <span className="tape" />
          <p className="text-xl md:text-2xl leading-relaxed text-[#1A1A1A]">
            we are retarded.<br />
            we are delusional.<br />
            we want big price.<br />
            we put propeller hat on the R.<br />
            we hold. we don't sell. we forget the keys.<br />
            <b className="text-[#E8742C]">this is the way.</b>
          </p>
          <div className="mt-4 flex items-center gap-2 text-base md:text-lg text-[#1A1A1A]/70">
            <span className="inline-block w-3 h-3 rounded-full bg-[#2A9D8F] border-2 border-[#1A1A1A]" />
            verified retard team
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
